import { render, staticRenderFns } from "./GlyphAdder.vue?vue&type=template&id=cba56ef0&scoped=true&"
import script from "./GlyphAdder.vue?vue&type=script&lang=js&"
export * from "./GlyphAdder.vue?vue&type=script&lang=js&"
import style0 from "./GlyphAdder.vue?vue&type=style&index=0&id=cba56ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba56ef0",
  null
  
)

export default component.exports